// extracted by mini-css-extract-plugin
export default {"header":"EstimationFactorDashboardPage_header__8cYRu"};